import { render, staticRenderFns } from "./CourseEquivalencies.vue?vue&type=template&id=46b361c6"
import script from "./CourseEquivalencies.vue?vue&type=script&lang=js"
export * from "./CourseEquivalencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports